import { render, staticRenderFns } from "./ibc_manage_home.vue?vue&type=template&id=c65f9a8a&scoped=true&"
import script from "./ibc_manage_home.vue?vue&type=script&lang=js&"
export * from "./ibc_manage_home.vue?vue&type=script&lang=js&"
import style0 from "./ibc_manage_home.vue?vue&type=style&index=0&id=c65f9a8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65f9a8a",
  null
  
)

export default component.exports